import { Attribute } from "../../../concepts/objects";

export const VideoStateAttr = new Attribute<'stopped' | 'playing'>('videoState', 'stopped');